import { sortBy } from 'lodash';
import { FC, useEffect } from 'react';
import useAsyncFetch from '../../../../hooks/use-async';
import useLocalStore from '../../../../hooks/use-local-store';
import {
  PropriedadesService,
  ParametroService,
  SafrasService,
  AtividadesService,
} from '../../../../services';
import { TratamentoSementesFormType } from '../types';
import { Form } from '../form-controller';

const TratamentoDeSementesParametrosHead: FC<TratamentoSementesFormType> = ({
  formObject,
  tratamentoSementes,
}) => {
  const currentPropriedade = useLocalStore('currentPropriedade').value;
  const { setValue, watch, getValues, reset } = formObject.form;

  const clienteAgrogestao = watch('clienteAgrogestao');

  const { data: propriedades } = useAsyncFetch(
    {
      callback: async () =>
        sortBy(await PropriedadesService.list(), 'descricao'),
      errorMessage: 'Falha ao carregar as propriedades.',
      withLoader: true,
    },
    [],
  );

  const { data: parametro } = useAsyncFetch(
    {
      callback: () => ParametroService.parametro(),
      errorMessage: 'Falha ao carregar os parâmetros.',
      withLoader: true,
    },
    [],
  );

  const { data: safras } = useAsyncFetch(
    {
      callback: () => SafrasService.list(),
      errorMessage: 'Falha ao carregar as safras.',
      withLoader: true,
    },
    [],
  );

  const { data: atividades } = useAsyncFetch(
    {
      callback: () => AtividadesService.list(),
      errorMessage: 'Falha ao carregar as atividades.',
      withLoader: true,
    },
    [],
  );

  useEffect(() => {
    setValue('clienteAgrogestao', !parametro?.naoClienteAgrogestao || false);
  }, [parametro?.naoClienteAgrogestao, setValue]);

  useEffect(() => {
    if (!safras) return;

    const novaSafra = safras.find((safra) =>
      tratamentoSementes
        ? tratamentoSementes.safraId === safra.id
        : safra.current,
    );

    setValue('safra', novaSafra);
  }, [safras, setValue, tratamentoSementes]);

  useEffect(() => {
    const novaPropriedadeId =
      tratamentoSementes?.propriedadeId || currentPropriedade?.id;

    if (!propriedades || !novaPropriedadeId) return;

    const propriedade = propriedades.find(({ id }) => novaPropriedadeId === id);
    setValue('propriedade', propriedade);
  }, [currentPropriedade, propriedades, setValue, tratamentoSementes]);

  useEffect(() => {
    if (!tratamentoSementes || !atividades) return;

    const atividade = atividades.find(
      (item) => item.id === tratamentoSementes.atividadeId,
    );

    reset({
      ...getValues(),
      atividade,
    });
  }, [tratamentoSementes, getValues, reset, atividades]);

  return (
    <div className="grid xl:col-10 md:col-11">
      <Form.Dropdown
        options={propriedades}
        dataKey="id"
        optionLabel="descricao"
        label="Propriedade:"
        name="propriedade"
        containerClassName={`${clienteAgrogestao ? 'col-4' : 'col-3'}`}
      />
      <Form.Dropdown
        options={safras}
        dataKey="id"
        optionLabel="descricao"
        label="Safra:"
        name="safra"
        containerClassName={`${clienteAgrogestao ? 'col-4' : 'col-3'}`}
      />
      <Form.Dropdown
        options={atividades}
        dataKey="id"
        optionLabel="descricao"
        label="Atividade:"
        name="atividade"
        containerClassName={`${clienteAgrogestao ? 'col-4' : 'col-3'}`}
      />
    </div>
  );
};

export default TratamentoDeSementesParametrosHead;
